import { FormField } from "@/interfaces/dashboard";
import {DropdownButton} from "@/UI/Button";

interface DynamicFormProps {
  fields: FormField[];
  values: Record<string, string>;
  onChange: (name: string, value: string) => void;
  onSubmit: (e: React.FormEvent) => void;
  error?: string;
  submitLabel?: string;
  onCancel?: () => void;
}

const DynamicForm: React.FC<DynamicFormProps> = ({
  fields,
  values,
  onChange,
  onSubmit,
  error,
  submitLabel = 'Submit',
  onCancel,
}) => {
  return (
    <form onSubmit={onSubmit} className="space-y-4 ">
      {fields.map((field) => (
        <div key={field.id}>
          <label htmlFor={field.id} className="block text-sm font-medium mb-2 text-[var(--primaryText)]">
            {field.label}
          </label>
          {field.type === 'textarea' ? (
            <textarea
              id={field.id}
              name={field.name}
              rows={field.rows || 3}
              className="block w-full rounded-lg p-3 bg-[var(--hoverBackground)] border border-primaryBorder text-[var(--primaryText)] focus:outline-none focus:ring-2 focus:ring-primaryBtn"
              placeholder={field.placeholder}
              value={values[field.name] || ''}
              onChange={(e) => onChange(field.name, e.target.value)}
              required={field.required}
            />
          ) : (
            <input
              id={field.id}
              name={field.name}
              type={field.type}
              className="block w-full rounded-lg p-3 bg-[var(--hoverBackground)] border border-primaryBorder text-[var(--primaryText)] focus:outline-none focus:ring-2 focus:ring-primaryBtn"
              placeholder={field.placeholder}
              value={values[field.name] || ''}
              onChange={(e) => onChange(field.name, e.target.value)}
              required={field.required}
            />
          )}
        </div>
      ))}
      {error && <p className="text-sm text-error">{error}</p>}
      <div className="flex items-center justify-end gap-3 pt-4">
        {onCancel && (
          <button
            type="button"
            onClick={onCancel}
            className="py-2.5 px-5 rounded-lg text-sm font-medium bg-secondaryBackground border border-primaryBorder text-[var(--primaryText)] hover:bg-neutral transition-colors"
          >
            Cancel
          </button>
        )}
        <DropdownButton onClick={() => {onSubmit}} title={submitLabel} />
      </div>
    </form>
  );
};

export default DynamicForm;